
import React, { Component } from 'react';
import {checkText,getFullDate} from '../../../../util/util';
import './css/TrackDetailStatus.css';
class TrackDetailStatus extends Component {

    setStatus(status){
        let c = "secondary";
        if(status=="จอด")
            c = "info"
        else if(status=="วิ่ง")
            c = "success";
        else if(status=="เร็ว")
            c = "danger";

        return(<span className={"badge badge-" + c} style={{paddingLeft:8,paddingRight:8,width: 45}}>{status}</span>)
    }

    render() {
        console.log("xxx",this.props.trackListSelect)
        let driver_name = this.props.trackListSelect?this.props.trackListSelect.driver_name:"";
        let device_no = this.props.trackListSelect?this.props.trackListSelect.device_info.device_no:"";
        if(this.props.trackListSelect && this.props.trackListSelect.driver_by_tracker){
            device_no +="(รูดบัตร)";
            driver_name += " " + this.props.trackListSelect.driver_no; 
        }
            

        return (
            !this.props.trackListSelect?<div></div>:
            <div className = "detail-status panel">
                <table style={{width:"100%",fontSize:13}} >
                    <tr>
                        <td className="tb-header">
                            <b>ทะเบียน</b>
                        </td>
                        <td>
                            {checkText(device_no,"-")}
                        </td>
                        <td className="tb-header">
                            <b>รายละเอียด</b>
                        </td>
                        <td>
                            {checkText(this.props.trackListSelect.device_info.detail,"-")}
                        </td>
                    </tr>
                    <tr>
                        <td className="tb-header">
                            <b>GSM</b>
                        </td>
                        <td>
                            {checkText(this.props.trackListSelect.gsm,"-")}
                        </td>
                        <td className="tb-header">
                            <b>GPS</b>
                        </td>
                        <td>
                            {checkText(this.props.trackListSelect.gps,"-")}
                        </td>
                    </tr>
                    <tr>
                        <td className="tb-header">
                            <b>คนขับ</b>
                        </td>
                        <td>
                            {checkText(driver_name,"-")}
                        </td>
                        <td className="tb-header">
                            <b>เบอร์โทร</b>
                        </td>
                        <td>
                            {checkText(this.props.trackListSelect.device_info.driver_contact,"-")}
                        </td>
                    </tr>
                    <tr>
                        <td className="tb-header">
                            <b>หมายเหตุ</b>
                        </td>
                        <td>
                            {checkText(this.props.trackListSelect.remarks,"-")}
                        </td>
                        <td className="tb-header">
                            <b>ครบกำหนด</b>
                        </td>
                        <td>
                            {getFullDate(this.props.trackListSelect.device_info.expire_date)}
                        </td>
                    </tr>
                    <tr>
                        <td className="tb-header">
                            <b>สถานะ</b>
                        </td>
                        <td>
                            {this.setStatus(this.props.trackListSelect.status)}
                        </td>
                        <td className="tb-header">
                            <b>เร็ว</b>
                        </td>
                        <td>
                            {this.props.trackListSelect.speed}
                         
                        </td>
                    </tr>
                    <tr>
                        <td className="tb-header">
                            <b>sensor</b>
                        </td>
                        <td>
                        {this.props.trackListSelect.device_info.sensor?this.props.trackListSelect.device_info.sensor.name + "" +this.props.trackListSelect.device_info.sensor.status:"-"}
                        </td>
                        <td className="tb-header">
                            <b>น้ำมั้น</b>
                        </td>
                        <td>
                        {this.props.trackListSelect.fuel}%
                        </td>
                    </tr>
                    <tr>
                        <td className="tb-header">
                            <b>อุณหภูมิ</b>
                        </td>
                        <td colSpan={3}>
                        <b>{checkText(this.props.trackListSelect.temperature_sensor_no,"-")}</b>
                
                        </td>
                        
                    </tr>
                    <tr>
                        <td className="tb-header">
                            <b>สถานที่</b>
                        </td>
                        <td colSpan={3}>
                        <b>{checkText(this.props.trackListSelect.place.replace("$",""))}</b>
                
                        </td>
                        
                    </tr>
                    <tr>
                        <td className="tb-header">
                            <b>ละติจูด</b>
                        </td>
                        <td>
                        {checkText(this.props.trackListSelect.latitude)}
                        </td>
                        <td className="tb-header">
                            <b>ลองติจูด</b>
                        </td>
                        <td>
                        {checkText(this.props.trackListSelect.longitude)}
                        </td>
                    </tr>

                </table>
            </div>
           
        );
    }
}
export default TrackDetailStatus;


// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/TrackDetailStatus/TrackDetailStatus.js